enum CounterpartyType {
	/** Потребитель/Заказчик */
	Consumer = 1,
	/** Поставщик */
	Supplier = 2,
	/** Подрядчик */
	Contractor = 3,
}

export default CounterpartyType;